import { useEffect, useState } from "react";
import { message, Card, Form, Select, Input, DatePicker, Row, Col, Button, Flex } from "antd";
import { dateFormat, menuLinks, notifyMessages, requiredMessages } from "../../utils/constants";
import { PageHeader } from "../../components/common/pageHeader";
import { Link, useParams, useNavigate } from "react-router";
import { SaveOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useCurrentUserContext } from "../../context/currentUserContext.js";
import dayjs from 'dayjs';
import ContentLoader from "../../components/common/contentLoader";
import DistinteDocumentServices from "../../services/distinteDocumentServices.js";
import { handleDateConvertForApis } from "../../utils/functions.js";
import { fetchSuppliersList } from "../../state/slices/suppliersListSlice.js";


const DistinteEditDocument = () => {
    const urlParams = useParams();
    const { currentUser } = useCurrentUserContext();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [fieldsChanged, setFieldsChanged] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const [documentData, setDocumentData] = useState(null);
    const regionsList = useSelector(state => state.regions.regions);
    const documentTypesDistinteList = useSelector(state => state.docTypes.docTypesDistinte);
    const suppliersList = useSelector(state => state.suppliers.suppliers);


    useEffect(() => {
        getDocumentData(urlParams.id, currentUser.id);
    }, []);

        useEffect(() => {
            if (!currentUser) return;
            dispatch(fetchSuppliersList(currentUser.lastSelectedCategory, false, currentUser.id));
        }, [dispatch, currentUser]);

    const getDocumentData = async (documentId, userId) => {
        try {
            const respData = await DistinteDocumentServices.getDocumentDetails(documentId, userId);
            if (respData.success) {
                setDocumentData(respData.responseObject.value.documentDetails_Distinte_DTO);
            } else {
                message.error(notifyMessages.errorAccured);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
        }
    };


    const updateData = async (values) => {

        values["id"] = documentData.id;
        values["lastEditedUser"] = currentUser.id;
        values.dateAdded = handleDateConvertForApis(values.dateAdded);
        const firstDay = values.month.startOf('month');
        values.month = handleDateConvertForApis(firstDay);

        console.log("values", values)

        setLoadingButton(true);
        try {
            const respData = await DistinteDocumentServices.updateDocument(values);
            if (respData.success) {
                message.success(notifyMessages.operationSuccess);
                navigate(`${menuLinks.distinte}/view/id/${urlParams.id}`);
            } else {
                message.error(respData.ErrorDetail?.ErrorMessage || notifyMessages.errorAccured);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
        } finally {
            setLoadingButton(false);
        }
    };


    return (
        <div className="edit-document">

            <PageHeader title={"Modifica documento"} />

            {!documentData && <ContentLoader />}

            {documentData && (
                <>
                    <Card title="Dati documento" size="small" className="editCard">
                        <Form
                            id="editDocument"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 8 }}
                            onFinish={updateData}
                            onValuesChange={() => setFieldsChanged(true)}
                        >

                            <Form.Item
                                label="Mese"
                                name="month"
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                                initialValue={documentData.month ? dayjs(documentData.month) : documentData.month}
                            >
                                <DatePicker placeholder="Selezione mese" picker="month" format={'MM/YYYY'} />
                            </Form.Item>


                            <Form.Item
                                label="CNA Provinciale"
                                name="regionId"
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                                initialValue={documentData.regionId}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="label"
                                    options={regionsList}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Manutentore"
                                name="supplierID"
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                                initialValue={documentData.supplierId}
                                >

                                <Select
                                    showSearch
                                    optionFilterProp="label"
                                    placeholder="Manutentore"
                                    options={suppliersList}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Tipo"
                                name="DocumentTypeDistinte"
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                                initialValue={documentData.documentTypeDistinte}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="label"
                                    options={documentTypesDistinteList}
                                />
                            </Form.Item>


                            <Form.Item
                                label="Batch"
                                name="Flux"
                                initialValue={documentData.flux}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="Data caricamento"
                                name="dateAdded"
                                rules={[{ required: true, message: requiredMessages.requiredField }]}
                                initialValue={documentData.dateAdded ? dayjs(documentData.dateAdded) : null}
                            >
                                <DatePicker format={dateFormat} />
                            </Form.Item>

                            <Form.Item
                                label="Note"
                                name="notes"
                                initialValue={documentData.notes}
                            >
                                <Input.TextArea rows={3} />
                            </Form.Item>
                        </Form>
                    </Card>

                    <Row gutter={24} >
                        <Col span={24} className="modifyDocButtons">
                            <Flex gap="small" wrap>
                                <Button type="default">
                                    <Link to={`${menuLinks.distinte}/view/id/${urlParams.id}`}>Annulla</Link>
                                </Button>

                                <Button
                                    loading={loadingButton}
                                    type="primary"
                                    htmlType="submit"
                                    disabled={!fieldsChanged}
                                    form="editDocument"
                                >
                                    <SaveOutlined /> Salva
                                </Button>
                            </Flex>
                        </Col>
                    </Row>
                </>
            )}
        </div>
    );
};

export default DistinteEditDocument;
